import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'
import { IAkOdePosInsatallmentHistory } from '../models/models'

export class ListAkOdePosInsatallmentHistoryApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/posTransactionAkOde/listAkOdePosInsatallmentHistory',
      requesterInfo,
    })
  }

  public async listAkOdePosInsatallmentHistory(guid: string): Promise<IAkOdePosInsatallmentHistory[]> {
    this.props.url = `${this.props.url}/?guid=${guid}`
    return await this.getAsync<IAkOdePosInsatallmentHistory[]>()
  }
}

